function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("title", null, "\n    cms-email-campaign-signup-single\n  ");

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M34.85,34.65H5.05a4,4,0,0,1-4-4V9.31a4,4,0,0,1,4-4h29.8a4,4,0,0,1,4,4V30.69A4,4,0,0,1,34.85,34.65ZM5.05,7.6A1.7,1.7,0,0,0,3.34,9.31V30.69A1.7,1.7,0,0,0,5.05,32.4h29.8a1.71,1.71,0,0,0,1.72-1.71V9.31A1.71,1.71,0,0,0,34.85,7.6Z",
  fill: "#231f20"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M2.59,33.4a1.13,1.13,0,0,1-.78-1.94l13-12.5a1.12,1.12,0,1,1,1.56,1.62l-13,12.51A1.1,1.1,0,0,1,2.59,33.4Z",
  fill: "#231f20"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M37.31,33.4a1.12,1.12,0,0,1-.78-.31l-13-12.51A1.12,1.12,0,0,1,25.07,19l13,12.5a1.13,1.13,0,0,1-.78,1.94Z",
  fill: "#231f20"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M19.94,23.33a5.27,5.27,0,0,1-3.56-1.46L2.2,8.18A1.13,1.13,0,0,1,3.77,6.56L17.93,20.24a2.73,2.73,0,0,0,3.91,0l14.3-13.7a1.12,1.12,0,1,1,1.55,1.63L23.41,21.86A4.87,4.87,0,0,1,19.94,23.33Z",
  fill: "#231f20"
});

function SvgCmsEmailCampaignSignupSingle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "Layer 1",
    viewBox: "0 0 40 40"
  }, props), _ref, _ref2, _ref3, _ref4, _ref5);
}

export default SvgCmsEmailCampaignSignupSingle;